export const groundObj = `
# Blender 5.0.1
# www.blender.org
o Plane
v -3.000000 0.000000 3.000000
v 3.000000 0.000000 3.000000
v -3.000000 0.000000 -3.000000
v 3.000000 0.000000 -3.000000
v -3.000000 0.019105 3.000000
v 3.000000 0.019105 3.000000
v -3.000000 0.019105 -3.000000
v 3.000000 0.019105 -3.000000
vn -0.0000 -1.0000 -0.0000
vn -0.0000 1.0000 -0.0000
vn -0.0000 -0.0000 -1.0000
vn -0.0000 -0.0000 1.0000
vn 1.0000 -0.0000 -0.0000
vn -1.0000 -0.0000 -0.0000
vt 0.000000 1.000000
vt 1.000000 0.000000
vt 0.000000 0.000000
vt 1.000000 1.000000
s 0
f 3/1/1 2/2/1 1/3/1
f 6/2/2 7/1/2 5/3/2
f 3/1/3 8/4/3 4/4/3
f 2/2/4 5/3/4 1/3/4
f 4/4/5 6/2/5 2/2/5
f 1/3/6 7/1/6 3/1/6
f 3/1/1 4/4/1 2/2/1
f 6/2/2 8/4/2 7/1/2
f 3/1/3 7/1/3 8/4/3
f 2/2/4 6/2/4 5/3/4
f 4/4/5 8/4/5 6/2/5
f 1/3/6 5/3/6 7/1/6

`;

export const cubeObj = `
# Blender 5.0.1
# www.blender.org
o Cube
v 1.000000 1.000000 -1.000000
v 1.000000 -1.000000 -1.000000
v 1.000000 1.000000 1.000000
v 1.000000 -1.000000 1.000000
v -1.000000 1.000000 -1.000000
v -1.000000 -1.000000 -1.000000
v -1.000000 1.000000 1.000000
v -1.000000 -1.000000 1.000000
vn -0.0000 1.0000 -0.0000
vn -0.0000 -0.0000 1.0000
vn -1.0000 -0.0000 -0.0000
vn -0.0000 -1.0000 -0.0000
vn 1.0000 -0.0000 -0.0000
vn -0.0000 -0.0000 -1.0000
vt 0.875000 0.500000
vt 0.625000 0.750000
vt 0.625000 0.500000
vt 0.375000 1.000000
vt 0.375000 0.750000
vt 0.625000 0.000000
vt 0.375000 0.250000
vt 0.375000 0.000000
vt 0.375000 0.500000
vt 0.125000 0.750000
vt 0.125000 0.500000
vt 0.625000 0.250000
vt 0.875000 0.750000
vt 0.625000 1.000000
s 0
f 5/1/1 3/2/1 1/3/1
f 3/2/2 8/4/2 4/5/2
f 7/6/3 6/7/3 8/8/3
f 2/9/4 8/10/4 6/11/4
f 1/3/5 4/5/5 2/9/5
f 5/12/6 2/9/6 6/7/6
f 5/1/1 7/13/1 3/2/1
f 3/2/2 7/14/2 8/4/2
f 7/6/3 5/12/3 6/7/3
f 2/9/4 4/5/4 8/10/4
f 1/3/5 3/2/5 4/5/5
f 5/12/6 1/3/6 2/9/6

`;

export const floorObj = `
# Blender 5.0.1
# www.blender.org
o Plane
v -100.000000 0.000000 100.000000
v 100.000000 0.000000 100.000000
v -100.000000 0.000000 -100.000000
v 100.000000 0.000000 -100.000000
vn -0.0000 1.0000 -0.0000
vt 1.000000 0.000000
vt 0.000000 1.000000
vt 0.000000 0.000000
vt 1.000000 1.000000
s 0
f 2/1/1 3/2/1 1/3/1
f 2/1/1 4/4/1 3/2/1

`